import React from 'react'

import { AutorizacaoAbsorventesModal } from './AutorizacaoAbsorventesModal'

interface AutorizacaoAbsorventesListaCidadaoModalProps {
  open: boolean
  cidadaoId: ID
  onClose: () => void
}

export function AutorizacaoAbsorventesListaCidadaoModal(props: Readonly<AutorizacaoAbsorventesListaCidadaoModalProps>) {
  const { open, cidadaoId, onClose: handleClose } = props
  if (!open) return null
  return <AutorizacaoAbsorventesModal open={open} cidadaoId={cidadaoId} onClose={handleClose} />
}
